export * from './abteilung-entfernt.interface';
